import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { ModalService } from '@d-services';

@Component({
  selector: 'app-base-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
})
export class BaseSpinnerComponent {
  showLoading$ = this.modalService.showLoading$;
  constructor(private modalService: ModalService) {}

  checkShowLoading() {
    return this.showLoading$.value > 0;
  }
}
